import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Contributor, Roles, Instruments } from "types/contributor";


export const useContributors = () => {
  const [contributors, setContributors] = React.useState<Contributor[]>([]);
  const [roles, setRoles] = React.useState<Roles[]>([]);
  const [instruments, setInstruments] = React.useState<Instruments[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const [creating, setCreating] = React.useState(false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      await getContributors();
      await getContributorsRoles();
      await getContributorsInstruments();
    })();
  }, []);

  const getContributors = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Contributors}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setContributors(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const getContributorsRoles = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.ContributorsRoles}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setRoles(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const getContributorsInstruments = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.ContributorsInstruments}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setInstruments(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const createContributor = async (name: string, roleIds: string[], instrumentIds: string[]) => {
    
    try {
      setCreating(true);
      const result = await axios.post(
        `${API_BASE_URL}${API_URLS.Contributors}`,
        { name, role_ids: roleIds, instrument_ids: instrumentIds },
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getContributors();
      return result.data.data;
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  const removeContributor = async (id: string) => {
    try {
      setCreating(true);
      await axios.delete(
        `${API_BASE_URL}${API_URLS.Artists}/${id}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getContributors();
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

 

  return { contributors, roles, instruments, creating, fetching, createContributor, removeContributor };
};
